import { pxToUnit, resolveTheme } from "../cjs/tombacCommons";
export const altFontFamily = _ref => {
  let {
    theme
  } = _ref;
  return resolveTheme(theme).typography.altFontFamily;
};
export const altText = function () {
  let attributes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return text({
    ...attributes,
    fontFamily: altFontFamily
  });
};
export const fontFamily = _ref2 => {
  let {
    theme
  } = _ref2;
  return resolveTheme(theme).typography.defaultFontFamily;
};
export const text = function () {
  let {
    color,
    fontFamily,
    fontSize,
    fontWeight,
    lineHeight,
    withDefaults = true
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _ref3 => {
    var _ref4, _ref5;
    let {
      theme
    } = _ref3;
    const {
      baseUnit,
      colors,
      typography: {
        defaultColor,
        defaultFontSize,
        defaultFontWeight,
        defaultLineHeight,
        defaultFontFamily
      }
    } = resolveTheme(theme);
    const styles = {
      color: (_ref4 = typeof color === "function" ? color({
        theme
      }) : color) !== null && _ref4 !== void 0 ? _ref4 : withDefaults ? colors[defaultColor[0]][defaultColor[1]] : undefined,
      fontFamily: (_ref5 = typeof fontFamily === "function" ? fontFamily({
        theme
      }) : fontFamily) !== null && _ref5 !== void 0 ? _ref5 : withDefaults ? defaultFontFamily : undefined,
      fontSize: withDefaults || fontSize !== undefined ? pxToUnit(fontSize !== null && fontSize !== void 0 ? fontSize : defaultFontSize, baseUnit) : undefined,
      fontWeight: fontWeight !== null && fontWeight !== void 0 ? fontWeight : withDefaults ? defaultFontWeight : undefined,
      lineHeight: lineHeight !== null && lineHeight !== void 0 ? lineHeight : withDefaults ? defaultLineHeight : undefined
    };
    if (withDefaults) {
      Object.assign(styles, {
        textRendering: "optimizeLegibility",
        WebkitFontSmoothing: "antialiased",
        MozOsxFontSmoothing: "grayscale"
      });
    }
    return styles;
  };
};
//# sourceMappingURL=textTools.js.map